import React, { Component } from 'react';
import cs from 'classnames';
import dateService  from '../../common/services/dateService';
import {
  Typography,
  createStyles,
  WithStyles,
  withStyles,
  Grid,
  CardContent,
  Card,
  Avatar,
  Theme,
} from '@material-ui/core';

import UserCard from './UserCard';
import _ from 'lodash';

const styles = (theme: Theme) => createStyles({
  mt1x: {
    marginTop: theme.spacing.unit * 2,
    MozBoxShadow: '0px 0px 10px rgba(0, 0, 0, 0.168337)',
    WebkitBoxShadow: '0px 0px 10px rgba(0, 0, 0, 0.168337)',
  },
  cardMain: {
    height: 543,
    position: 'relative',
    overflowY: "auto",
    overflowX: "hidden",
  },
  cardContentRoot: {
  },
  listTypo: {
    fontSize: '13px',
    lineHeight:'20px',
  },
  bold: {
    fontWeight: "bold",
  },
  noContent: {
    margin: 0,
    position: "absolute",
    top: '50%',
    left: '50%',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
  },
  UserCard: {
    padding: "5px !important",
  },
  colorAvatar: {
    width: '60px',
    height: '60px',
    margin: '10px',
    color: '#fff',
  },
  listTypo1:{
    fontWeight:'normal',
    fontSize: '13px',
    lineHeight:'20px',
  },
  listTypo2:{
    fontWeight:'normal',
    fontSize: '13px',
    lineHeight: '20px',

  },
});

interface MyCoursesProps extends WithStyles<typeof styles> {
  myCourses: any[],
}
const MyCourses = (props: MyCoursesProps) => {
  const { classes,myCourses } = props;
  return (
    <Card className={`${classes.mt1x} ${classes.cardMain}`}>
      <CardContent className={classes.cardContentRoot}>
        <Grid item xs>
          <Typography variant="h5" noWrap>
            My Courses
                </Typography>
        </Grid>
        {
          !_.isEmpty(myCourses) ? _.map(myCourses, (course, i) => (
        <Card className={classes.mt1x} key={`mycourses-${i}`}>
          <CardContent className={classes.UserCard}>
          <Grid container alignItems="center" spacing={8} >
              <Grid item>
                <Avatar className={classes.colorAvatar}></Avatar>
              </Grid>
              <Grid item xs="auto">
                <Typography variant="subtitle1" className={cs(classes.bold, classes.listTypo)}>{course.name}</Typography>
                <Typography variant="subtitle1" className={classes.listTypo1}>{course.goals}</Typography>
                <Typography variant="subtitle1" className={classes.listTypo2}>Last Activity: 
                {!_.isEmpty(course.activity) ?
                ` ${dateService.getTimeAgo(course.activity)} ago`:' '
                }
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
          ))
          : <Typography className={classes.noContent} color="textSecondary">No Course</Typography>
        }

      </CardContent>
    </Card>
  )
}

export default withStyles(styles)(MyCourses)